import React from 'react';
import { motion } from 'framer-motion';
import KindnessForm from '../components/KindnessForm';
import KindnessGallery from '../components/KindnessGallery';
import KindnessIdCard from '../components/KindnessIdCard';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHeart, FiSmile, FiShield } = FiIcons;

const Home = ({ kindnessId, setKindnessId }) => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/* Hero Section */}
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="text-center mb-12"
      >
        <h1 className="text-4xl md:text-6xl font-bold gradient-text mb-4">
          Spread Kindness Anonymously
        </h1>
        <h2 className="text-2xl font-bold mb-6 kaas-subtitle">
          KAAS – Kindness as a Service
        </h2>
        <p className="text-xl text-text mb-12 max-w-2xl mx-auto font-medium">
          Send uplifting messages, compliments, and encouragement to brighten someone's day. No accounts needed, completely anonymous, just pure kindness.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.1, duration: 0.5 }}
            className="clay-card text-center hover:transform hover:scale-105 transition-all duration-300"
          >
            <div className="clay-button-pink p-6 mx-auto mb-6 w-fit">
              <SafeIcon icon={FiHeart} className="text-3xl heart-logo" />
            </div>
            <h3 className="text-xl font-bold text-heading mb-3">Anonymous Kindness</h3>
            <p className="text-text font-medium">
              Send messages without revealing your identity. Pure, selfless kindness.
            </p>
          </motion.div>

          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="clay-card text-center hover:transform hover:scale-105 transition-all duration-300"
          >
            <div className="clay-button-yellow p-6 mx-auto mb-6 w-fit">
              <SafeIcon icon={FiSmile} className="text-3xl text-heading" />
            </div>
            <h3 className="text-xl font-bold text-heading mb-3">Mental Health Focus</h3>
            <p className="text-text font-medium">
              Designed to promote positivity and support emotional wellbeing.
            </p>
          </motion.div>

          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.5 }}
            className="clay-card text-center hover:transform hover:scale-105 transition-all duration-300"
          >
            <div className="clay-button-green p-6 mx-auto mb-6 w-fit">
              <SafeIcon icon={FiShield} className="text-3xl text-heading" />
            </div>
            <h3 className="text-xl font-bold text-heading mb-3">Safe & Moderated</h3>
            <p className="text-text font-medium">
              All messages are filtered for positivity and reviewed for safety.
            </p>
          </motion.div>
        </div>
      </motion.div>

      {/* Kindness ID Card */}
      {kindnessId && <KindnessIdCard kindnessId={kindnessId} setKindnessId={setKindnessId} />}

      {/* Kindness Form */}
      <KindnessForm kindnessId={kindnessId} />

      {/* Gallery */}
      <KindnessGallery limit={6} />
    </div>
  );
};

export default Home;